import { useRef } from "react";

/**
 * Verify if the composent has been rendered for the first time
 */
export const useFirstRender = () => {
    const ref = useRef(true);
    const firstRender = ref.current;
    ref.current = false;
    return firstRender;
};
